import TILE_SETS from "./tilesets.json";

export const MAP_STYLE = {
  street: "mapbox://styles/mapbox/standard",
  satellite: "mapbox://styles/mapbox/standard-satellite",
};

export const FIRE_HAZARD_COLOR_STOPS = [
  [0.05, "#9efc9c"],
  [0.1, "#93fb5b"],
  [0.2, "#edf42a"],
  [0.3, "#fabe6b"],
  [0.4, "#ea9c0b"],
  [0.5, "#fb6a6a"],
  [0.6, "#e60a0a"],
  [0.7, "#ab0707"],
  [0.8, "#6d0303"],
  [0.9, "#000000"],
];

export const EARTHQUAKE_HAZARD_COLOR_STOPS = [
  [0.11270000040531158, "#b0fc97"],
  [0.13, "#e7f65a"],
  [0.19, "#f59414"],
  [0.23, "#ea7406"],
  [0.29, "#f82a2a"],
  [0.37, "#b70606"],
];

export const EARTHQUAKE_HAZARD_SOURCE_URL = "mapbox://georgemouts.c81uycf1";
export const EARTHQUAKE_HAZARD_SOURCE_LAYER = "pga_merged";
export const EARTHQUAKE_TECTONIC_SOURCE_URL = "mapbox://georgemouts.4b6k40u5";
export const EARTHQUAKE_TECTONIC_SOURCE_LAYER = "Tectonic_Lines_Greece-ailmmz";
export const EARTHQUAKE_FAULTS_SOURCE_URL = "mapbox://georgemouts.9ar4csf5";
export const EARTHQUAKE_FAULTS_SOURCE_LAYER = "Active_Fault_Greece-22wjq5";

const [earthquakeHazardDefaultStop, ...earthquakeHazardRemainingStops] =
  EARTHQUAKE_HAZARD_COLOR_STOPS;

export const earthquakeHazardFillLayer = {
  id: "earthquake-hazard-layer-fill",
  type: "fill",
  "source-layer": EARTHQUAKE_HAZARD_SOURCE_LAYER,
  paint: {
    "fill-color": [
      "step",
      ["coalesce", ["to-number", ["get", "band_1"]], 0],
      earthquakeHazardDefaultStop[1],
      ...earthquakeHazardRemainingStops.flat(),
    ],
    "fill-opacity": 0.56,
    "fill-outline-color": "rgba(0, 0, 0, 0)",
  },
};

export const earthquakeTectonicPlatesLayer = {
  id: "earthquake-tectonic-plates-layer",
  type: "line",
  "source-layer": EARTHQUAKE_TECTONIC_SOURCE_LAYER,
  paint: {
    "line-color": "#240566",
    "line-width": 1,
  },
};

export const earthquakeActiveFaultsLayer = {
  id: "earthquake-active-faults-layer",
  type: "line",
  "source-layer": EARTHQUAKE_FAULTS_SOURCE_LAYER,
  paint: {
    "line-color": [
      "match",
      ["get", "dangerous_class"],
      "Medium",
      "hsl(39, 93%, 47%)",
      "High",
      "hsl(0, 89%, 53%)",
      "hsl(113, 52%, 48%)",
    ],
    "line-width": 1.25,
  },
};

export const earthquakeUnifiedHeatmapLayer = {
  id: "earthquake-unified-risk-heatmap",
  type: "heatmap",
  "source-layer": "seismic_data_output-dtohmh",
  paint: {
    "heatmap-weight": [
      "match",
      ["get", "risk"],
      "Low risk",
      0.2,
      "Medium risk",
      0.5,
      "High risk",
      1,
      0, // fallback
    ],
    "heatmap-intensity": [
      "interpolate",
      ["linear"],
      ["zoom"],
      0,
      1,
      10,
      1.3,
      12,
      1.5,
      14,
      2,
      15,
      3,
    ],
    "heatmap-radius": [
      "interpolate",
      ["linear"],
      ["zoom"],
      5,
      2,
      6,
      4,
      7,
      8,
      8,
      15,
      9,
      30,
      10,
      58,
      11,
      110,
      12,
      230,
      13,
      400,
      14,
      730,
      15,
      960,
      16,
      2700,
      17,
      4000,
      18,
      6000,
      19,
      10000,
      20,
      15000,
      21,
      20000,
    ],
    "heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 0, 0.6, 14, 0.6],
    "heatmap-color": [
      "interpolate",
      ["linear"],
      ["heatmap-density"],
      0,
      "rgba(0, 255, 0, 0)", // transparent
      0.2,
      "#f9fc21", // low risk (yellowish)
      0.5,
      "rgb(255, 149, 0)", // medium risk (orange)
      1,
      "rgb(255, 2, 2)", // high risk (red-orange)
    ],
  },
};

export const fireGenericLayer = {
  type: "fill",
  paint: {
    "fill-color": ["get", "color"],
    "fill-opacity": 0.5,
  },
};

export const floodRiversLayer = {
  id: "flood-rivers-layer",
  type: "line",
  "source-layer": "gdf_Hydro_Net_Copernicus-7cr08g",
  paint: {
    "line-color": "#0a1929",
    "line-width": [
      "interpolate",
      ["linear"],
      ["zoom"],
      8,
      [
        "interpolate",
        ["linear"],
        ["get", "STRAHLER"],
        1,
        1,
        2,
        2,
        3,
        3,
        4,
        4,
        5,
        5,
        6,
        6,
        7,
        8,
        8,
        10,
      ],
      14,
      [
        "interpolate",
        ["linear"],
        ["get", "STRAHLER"],
        1,
        3,
        2,
        4,
        3,
        5,
        4,
        7,
        5,
        9,
        6,
        11,
        7,
        14,
        8,
        18,
      ],
      17,
      [
        "interpolate",
        ["linear"],
        ["get", "STRAHLER"],
        1,
        5,
        2,
        7,
        3,
        9,
        4,
        12,
        5,
        15,
        6,
        18,
        7,
        22,
        8,
        26,
      ],
    ],
  },
};

export const floodLakesLayer = {
  id: "flood-lakes-layer",
  type: "fill",
  "source-layer": "Lakes_Greece-9yufb7",
  paint: {
    "fill-color": "#0b65c2",
    "fill-opacity": 0.7,
  },
};

export const floodMultiPolygonLayer = {
  id: "flood-layer",
  type: "fill",
  "source-layer": "floods",
  paint: {
    "fill-color": "#0356fc",
    "fill-opacity": 0.5,
  },
};

export const MAPBOX_TILES = {
  greece: "mapbox://georgemouts.8udn2ckq",
  flood: "mapbox://georgemouts.9xz4u21u",
  rivers: "mapbox://georgemouts.b1pbodie",
  lakes: "mapbox://georgemouts.0fcpfau3",
  earthquake: "mapbox://georgemouts.6geksk71",
};

export const FLOOD_HAZARD_COLOR_STOPS_Z13 = [
  [0, "#e5fcd9"],
  [3.279, "#afe4f3"],
  [14.754, "#15a5d1"],
  [29.508, "#065fb2"],
  [40, "#3d0ec8"],
];

export const FLOOD_HAZARD_COLOR_STOPS = [
  [0, "#e5fcd9"],
  [14.754, "#15a5d1"],
  [29.508, "#065fb2"],
  [40, "#3d0ec8"],
];

export const FLOOD_HAZARD_SOURCE_LAYER = "ead";

// Flood hazard is served from three tilesets, each scoped to a zoom range so
// every zoom level loads tiles at an appropriate resolution. The value lives in
// `ead_mean` on most tilesets, but the highest-zoom one exposes it as `ead`.
// Each tileset also has its own color stops, since the underlying value ranges
// differ per zoom level.
export const FLOOD_HAZARD_TILESETS = [
  {
    id: "flood-hazard-z0",
    url: "mapbox://georgemouts.oi3rou",
    minzoom: 0,
    maxzoom: 10,
    property: "ead_mean",
    useTransparentOutline: false,
    colorStops: FLOOD_HAZARD_COLOR_STOPS,
  },
  {
    id: "flood-hazard-z10",
    url: "mapbox://georgemouts.n6s210",
    minzoom: 10,
    maxzoom: 13,
    property: "ead_mean",
    useTransparentOutline: false,
    colorStops: FLOOD_HAZARD_COLOR_STOPS,
  },
  {
    id: "flood-hazard-z13",
    url: "mapbox://georgemouts.greece-ead-z12-14-073151",
    minzoom: 13,
    maxzoom: 24,
    property: "ead",
    useTransparentOutline: true,
    colorStops: FLOOD_HAZARD_COLOR_STOPS_Z13,
  },
];

// Builds the step color ramp for a flood-hazard layer, keyed on the given
// feature property and color stops (both vary per tileset).
export const buildFloodHazardFillColor = (property, colorStops) => {
  const [defaultStop, ...remainingStops] = colorStops;
  return [
    "step",
    ["coalesce", ["to-number", ["get", property]], 0],
    defaultStop[1],
    ...remainingStops.flat(),
  ];
};

export const floodHazardLayer = {
  type: "fill",
  "source-layer": FLOOD_HAZARD_SOURCE_LAYER,
  paint: {
    "fill-opacity": 0.6,
  },
};

const TILES_PATH_PREFIX = "mapbox://";

const BLACK_LIST_TILE_NAMES = [
  // Turkey
  "CLMS_CLCPLUS_RAS_S2023_R10m_E58N19_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E58N18_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E58N14_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E57N20_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E59N20_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E59N19_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E59N18_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E59N17_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E58N22_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E58N21_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E58N20_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E57N22_03035_V01_R00",
  // Albania, Skopia
  "CLMS_CLCPLUS_RAS_S2023_R10m_E51N20_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E51N21_03035_V01_R00",
  "CLMS_CLCPLUS_RAS_S2023_R10m_E52N21_03035_V01_R00",
];

const isInBlackList = (name) =>
  BLACK_LIST_TILE_NAMES.includes(name) ||
  BLACK_LIST_TILE_NAMES.includes(name.replace("_low_", ""));

export const FIRE_TILES_HIGH_ZOOM = TILE_SETS.filter(
  (tileset) => tileset.name.startsWith("CLMS") && !isInBlackList(tileset.name),
).map((t) => ({
  url: `${TILES_PATH_PREFIX}${t.id}`,
  "source-layer": t.name,
}));

export const FIRE_TILES_LOW_ZOOM = TILE_SETS.filter(
  (tileset) =>
    tileset.name.startsWith("_low_CLMS") && !isInBlackList(tileset.name),
).map((t) => ({
  url: `${TILES_PATH_PREFIX}${t.id}`,
  "source-layer": t.name,
}));

// --- Historical hazard overlays (past events) ---------------------------
// Each hazard's past events live in its own Mapbox tileset. Only earthquake is
// available today; flood and fire URLs/source-layers arrive later — until then
// their consts stay null and the layers simply don't render.
export const HISTORICAL_EARTHQUAKE_SOURCE_URL =
  "mapbox://georgemouts.akr8bede204p";
export const HISTORICAL_EARTHQUAKE_SOURCE_LAYER = "3f41b379413753298d66";
export const HISTORICAL_FLOOD_SOURCE_URL = "mapbox://georgemouts.2szaqopt95qq";
export const HISTORICAL_FLOOD_SOURCE_LAYER = "2e56344d4f922b124eb8";
export const HISTORICAL_FIRE_SOURCE_URL = "mapbox://georgemouts.186xyrvrk20s";
export const HISTORICAL_FIRE_SOURCE_LAYER = "698d9fb423bfdb5256f1";

// Historical point radius grows smoothly with zoom: 4→5→6→7→8px.
const HISTORICAL_POINT_RADIUS = [
  "interpolate",
  ["linear"],
  ["zoom"],
  6,
  4,
  8,
  5,
  10,
  6,
  12,
  7,
  14,
  9,
];

// Flood points depict a real ~100 m ground radius. circle-radius is px-only,
// so convert via metersPerPixel(zoom) = 78271.517 * cos(lat) / 2^zoom
// (512px tiles), with lat fixed at 38° (center of Greece, ±5% across it).
// Below FLOOD_MIN_RADIUS_ZOOM the interpolate clamps to the first stop,
// keeping a visible minimum px radius at low zooms.
const FLOOD_POINT_RADIUS_METERS = 200;
const FLOOD_POINT_MIN_RADIUS_PX = 5;
const METERS_PER_PIXEL_AT_ZOOM_0 = 78271.517 * Math.cos((38 * Math.PI) / 180);
const floodRadiusPxAtZoom = (zoom) =>
  (FLOOD_POINT_RADIUS_METERS * 2 ** zoom) / METERS_PER_PIXEL_AT_ZOOM_0;
const FLOOD_MIN_RADIUS_ZOOM = Math.log2(
  (FLOOD_POINT_MIN_RADIUS_PX * METERS_PER_PIXEL_AT_ZOOM_0) /
    FLOOD_POINT_RADIUS_METERS,
);
const HISTORICAL_FLOOD_POINT_RADIUS = [
  "interpolate",
  ["exponential", 2],
  ["zoom"],
  FLOOD_MIN_RADIUS_ZOOM,
  FLOOD_POINT_MIN_RADIUS_PX,
  22,
  floodRadiusPxAtZoom(22),
];

// Historical point stroke grows smoothly with zoom over the same range: 1→2px.
const HISTORICAL_POINT_STROKE_WIDTH = [
  "interpolate",
  ["linear"],
  ["zoom"],
  6,
  1,
  10,
  2,
  13,
  3,
];

export const historicalEarthquakeLayer = {
  id: "historical-earthquake-layer",
  type: "circle",
  "source-layer": HISTORICAL_EARTHQUAKE_SOURCE_LAYER,
  paint: {
    "circle-radius": HISTORICAL_POINT_RADIUS,
    "circle-color": "#b70606",
    "circle-opacity": 1,
    "circle-stroke-width": HISTORICAL_POINT_STROKE_WIDTH,
    "circle-stroke-color": "#ffffff",
  },
};

// Renders from the grouped GeoJSON source built by useHistoricalFloodEvents
// (one feature per location), not straight from the tileset — so no
// "source-layer" here. Overlapping same-spot events would otherwise stack
// their 0.6 opacities and hover would only ever find the topmost one.
// Below FLOOD_MIN_RADIUS_ZOOM the circles are clamped min-size dots, so they
// render fully opaque; the 0.6 opacity only applies once they depict a real
// ground radius.
export const historicalFloodLayer = {
  id: "historical-flood-layer",
  type: "circle",
  paint: {
    "circle-radius": HISTORICAL_FLOOD_POINT_RADIUS,
    "circle-pitch-alignment": "map",
    "circle-color": "#065fb2",
    "circle-opacity": ["step", ["zoom"], 1, FLOOD_MIN_RADIUS_ZOOM, 0.65],
    "circle-stroke-width": HISTORICAL_POINT_STROKE_WIDTH,
    "circle-stroke-color": "#ffffff",
  },
};

// Invisible layer on the raw flood tileset. Mapbox only downloads tiles for
// sources referenced by a layer, so this keeps them loading for
// useHistoricalFloodEvents to read via querySourceFeatures.
export const historicalFloodLoaderLayer = {
  id: "historical-flood-loader",
  type: "circle",
  paint: {
    "circle-radius": 0,
    "circle-opacity": 0,
  },
};

// Event count shown on top of grouped flood circles that hold >1 event.
// Hidden at low zooms, where the min-size dots are too small to label.
export const historicalFloodCountLayer = {
  id: "historical-flood-count-layer",
  type: "symbol",
  minzoom: FLOOD_MIN_RADIUS_ZOOM,
  filter: [">", ["get", "count"], 1],
  layout: {
    "text-field": ["to-string", ["get", "count"]],
    "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
    "text-size": ["interpolate", ["linear"], ["zoom"], 6, 9, 12, 12, 13, 14],
    "text-allow-overlap": true,
    "text-ignore-placement": true,
  },
  paint: {
    "text-color": "#ffffff",
    "text-halo-color": "#065fb2",
    "text-halo-width": 1,
  },
};

export const historicalFireFillLayer = {
  id: "historical-fire-fill-layer",
  type: "fill",
  "source-layer": HISTORICAL_FIRE_SOURCE_LAYER,
  paint: {
    "fill-color": "#ab0fab",
    "fill-opacity": [
      "case",
      ["boolean", ["feature-state", "hover"], false],
      0.55, // darker when hovered
      0.4, // base
    ],
  },
};

export const historicalFireOutlineLayer = {
  id: "historical-fire-outline-layer",
  type: "line",
  "source-layer": HISTORICAL_FIRE_SOURCE_LAYER,
  paint: {
    "line-color": "#800080",
    "line-width": [
      "case",
      ["boolean", ["feature-state", "hover"], false],
      2, // wider when hovered
      1, // base
    ],
  },
};

// Drives generic rendering + hover interaction for the historical overlay of
// the currently selected hazard. `url === null` means "not available yet".
// Flood is rendered through a custom path in risksMap.js (grouped GeoJSON
// mirror of the tileset); its `layers` entry only feeds the hover layer ids.
export const HISTORICAL_HAZARD_CONFIG = {
  earthquake: {
    url: HISTORICAL_EARTHQUAKE_SOURCE_URL,
    sourceLayer: HISTORICAL_EARTHQUAKE_SOURCE_LAYER,
    layers: [historicalEarthquakeLayer],
  },
  flood: {
    url: HISTORICAL_FLOOD_SOURCE_URL,
    sourceLayer: HISTORICAL_FLOOD_SOURCE_LAYER,
    layers: [historicalFloodLayer, historicalFloodCountLayer],
  },
  fire: {
    url: HISTORICAL_FIRE_SOURCE_URL,
    sourceLayer: HISTORICAL_FIRE_SOURCE_LAYER,
    layers: [historicalFireFillLayer, historicalFireOutlineLayer],
  },
};

export const MARKER_LAYER_ID = "marker-circle-layer";
export const CIRCLE_LAYER_FILL_ID = "circle-fill";
export const CIRCLE_LAYER_OUTLINE_ID = "circle-outline";
